import type { ChromeStrings } from './ar';

/** Global chrome strings (English). */
export const en: ChromeStrings = {
  platformName: 'Marsad · National Decision Support Platform',
  platformTagline: 'Decision Support System — National Performance Indicators',
  updated: 'Data updated —',
  adminNote: 'Language & theme controlled by admin',
  langLabel: 'Language',
  themeLight: 'Light mode',
  themeDark: 'Dark mode',
  yearLabel: 'Period',
  stageLabel: 'Sub-sector',
  loading: 'Loading…',
  loginTitle: 'Sign in',
  loginSubtitle: 'National Decision Support Platform — authorized official use only',
  username: 'Username',
  password: 'Password',
  signIn: 'Sign in',
  signingIn: 'Verifying…',
  signOut: 'Sign out',
  loginError: 'Incorrect username or password',
  loginNote: 'Restricted access — activity may be logged.',
  deltaHint: 'Change vs. previous period',
  whatItMeans: 'What it means',
  betterHigh: 'Higher is better',
  betterLow: 'Lower is better',
  betterNeutral: 'Context-dependent',
  recTitle: 'Suggested improvement ideas & steps',
  recHint: 'Click to view suggested improvement steps',
  close: 'Close',
  navNational: 'National',
  nationalTitle: 'National Overview',
  nationalSubtitle: 'Cross-sector executive summary for strategic decision support',
  readinessIndex: 'National Readiness Index',
  targetsAtRisk: 'Targets at risk',
  subdomains: 'Sub-domains',
  viewDomain: 'View detail',
  navCommitments: 'Commitments',
  commitmentsTitle: 'National Commitments & Programs',
  commitmentsSubtitle: 'Delivery of strategic cross-sector programs',
  attentionTitle: 'Needs your attention',
  attentionEmpty: 'No critical items need attention right now.',
  momentumUp: 'Improved vs previous period',
  momentumDown: 'Declined vs previous period',
  momentumFlat: 'Stable vs previous period',
  delivery: 'Delivery',
  planned: 'Planned',
  progStatus: { 'on-track': 'On track', 'at-risk': 'At risk', 'off-track': 'Off track' },
  programsLabel: 'Programs',
  onTrackCount: 'On track',
  atRiskCount: 'At risk',
  offTrackCount: 'Off track',
  milestonesLabel: 'Key milestones',
  contributingKpis: 'Contributing indicators',
  sectorsTouched: 'Sectors involved',
  viewProgram: 'Program detail',
  navMethodology: 'Methodology',
  methodologyTitle: 'Indicator Methodology & Reference',
  methodologySubtitle: 'What each indicator means and how it is calculated',
  searchPlaceholder: 'Search an indicator, definition or formula…',
  noResults: 'No matching results',
  formulaLabel: 'Calculation',
  indicatorsBySector: 'Sector indicators',
  unitLabel: 'Unit',
  resultsCount: 'results',
  reasonOverdue: 'Overdue alert',
  reasonCritical: 'Critical alert',
  reasonOffTarget: 'Indicator far off target',
  reasonProgramRisk: 'Program off track',
  overviewTitle: 'National Overview',
  overviewSubtitle: 'Cross-sector executive summary for decision support',
  compositeLabel: 'Composite index',
  criticalAlerts: 'Critical alerts',
  keyIndicators: 'Key indicators',
  openDashboard: 'Open dashboard',
  printBriefing: 'Print briefing',
  targetLabel: 'Target',
  onTrack: 'Target achieved',
  nearTarget: 'Near target',
  offTarget: 'Off target',
  ownerLabel: 'Owner',
  dueLabel: 'Due',
  overdue: 'Overdue',
  alertState: {
    open: 'Open',
    'in-progress': 'In progress',
    resolved: 'Resolved',
  },
  errorTitle: 'Failed to load data',
  errorBody: 'Please check the connection or data source and try again.',
  status: {
    excellent: 'Excellent',
    good: 'Good',
    watch: 'Monitor',
    act: 'Intervene',
  },
};
